__webpack_require__.p = "/areas-blacklist-manager/ui/";